import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getItemWebStorage } from '../../../../features/webStorageSaver'
import { useAppSelector } from '../../../../stateManagement/hooks/redux'
import { MapTooltip } from '../../../../widgets/map/mapAddons/mapTooltip'
import MapWidget from '../../../../widgets/map/mapWidget/MapWidget'
import { LastYearsMapFilter } from '../../../lastYearsMapFilter'
import { getBasicObjectTypeLayer, getAllRoadObjectsLayer } from '../../../../widgets/map/mapFeatures/layers'
import { getObjectsOnMapPoint } from '../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint'
import { showMapTooltip } from '../../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip'
import { setMapTooltipIsVisible } from '../../../../stateManagement/reducers/MapTooltipSlice'
import { mapLayersDict } from '../../mapLayersDict'
import { setHighContrastModeIsEnabled } from '../../../../stateManagement/reducers/ContentHeaderSlice'
import ContentHeader from '../../../../widgets/contentHeader/ContentHeader'

const roadDiagnosticsSegmentsDefaultFilters = {
    mapFilter: "EventTypeId=1"
}

export function MapRoadDiagnosticsSegments() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapName = "RoadDiagnosticsSegments"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [isSmallWindow, setIsSmallWindow] = useState(true);
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const yearFilter = useAppSelector(state => state.mapFilters?.lastYearsMapFilters)?.[mapName] ?? {}
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')

    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[mapName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        const checkedYears = Object.entries(yearFilter).filter(([year, checked]: any) => checked).map(([year, checked]: any) => year)
        let layerFilter = `EventYear in (${checkedYears.join(',')})`
        const roadDiagnosticsSegmentsMapDefaultFilter = roadDiagnosticsSegmentsDefaultFilters?.mapFilter
        if (roadDiagnosticsSegmentsMapDefaultFilter) {
            layerFilter += ` and ${roadDiagnosticsSegmentsMapDefaultFilter}`
        }
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
        dispatch(setHighContrastModeIsEnabled(true))
    }, [yearFilter]);

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 440);
    }, [sideBarState, navigate])

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        const hasSeenYearForMobile = getItemWebStorage("lastYearsMapFilters")?.[mapName]
        if (!hasSeenYearForMobile && contentHeaderWidth < 440) {
            navigate('/app/map/RoadDiagnosticsSegments/filters')
        }
    }, [])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnMapPoint(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFindAlways",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" option="roadDiagnosticsSegments" />
            {!isSmallWindow && <LastYearsMapFilter filterType="header" numberOfYears={5} objectType={mapName} />}
            <div className={`map-widget-with-toast${!isSmallWindow ? ' road-diagnostics-segments' : ''}`}>
                <MapTooltip type={mapName} />
                <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} mapEventHandlers={mapEventHandlers} />
            </div>
        </>
    )
}
